import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding: 1rem 0.875rem;
  background-color: rgba(234, 102, 101, 0.1);
  border: 1px solid #ea6766;
  border-radius: 0.3125rem;
`

const Message = styled.div`
  color: #ea6766;
  font-size: 0.875rem;
`

const ErrorMessage = ({ message }) => (
  <Wrapper>
    <Message>
      <strong>Whoops!</strong> {message}
    </Message>
  </Wrapper>
)

ErrorMessage.propTypes = {
  message: PropTypes.string,
}

export default ErrorMessage



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/CompleteSignUp/Error/index.js